import {lazyRegister} from '@/Core/lazyRegister';
import './multi-selection-item.component.css';
import template from './multi-selection-item.component.html';
import {OptionModel} from "@components/Forms";
import '@/Components/Forms/checkbox-switch/checkbox-switch.component';
import '@/Directives/compileTemplate';
import {checkAllChildren} from "@core/global";

class MultiSelectionItemController {
    static $inject = ['$element'];
    item: OptionModel;
    itemTemplate: string;
    useCheckbox: boolean = true;
    onChange: (args: { $event: OptionModel }) => void;

    constructor(private $element) {
    }

    $onInit(): void {
        this.$element.addClass('multi-selection-item');
    }


    handleSubItemSelect() {
        if (this.item.children) {
            this.item.checked = !this.item.children.some(x => !x.checked);
        }

        this.onChange({$event: this.item});
    }

    handleItemSelect(e: boolean) {
        if (this.useCheckbox && this.item.children?.length > 0) {
            checkAllChildren(this.item, e);
        }

        this.onChange({$event: this.item});
    }

    handleItemClick() {
        if (this.useCheckbox) {
            return;
        }
        
        this.onChange({$event: this.item});
    }
}

export const MultiSelectionItemComponent: ng.IComponentOptions = {
    bindings: {
        item: '=',
        filterText: '=',
        itemTemplate: '<',
        useCheckbox: '<?',
        onChange: '&'
    },
    template: template,
    controller: MultiSelectionItemController
};

lazyRegister.component('multiSelectionItem', MultiSelectionItemComponent);
